import { render } from "./Home.vue?vue&type=template&id=d4aceafa"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=d4aceafa&lang=css"
script.render = render

export default script